import styled from "styled-components";

export const CardWrapper = styled.div`
	justify-content: center;
	display: flex;
	width: 274px;
	height: 427px;
	border-radius: 25px;
	border-top: 2px solid var(--border-color);
	border-bottom: 2px solid var(--border-color);
	background: var(--modal-bg);
	margin-bottom: 20px;

	@media (min-width: 1024px) {
		width: 554px;
		height: 318px;
		justify-content: flex-start;
		padding: 30px 40px 40px 40px;

		.ant-card-body {
			display: flex;
			flex-direction: column;
		}
	}
`;

export const CardTitle = styled.div`
	display: flex;
	color: var(--main-color);
	font-size: 20px;
	font-weight: 400;
	line-height: 24px;
	letter-spacing: 0.75px;
	padding-top: 20px;
	margin-bottom: 20px;
	justify-content: center;

	@media (min-width: 1024px) {
		justify-content: flex-start;
		padding-top: 0;
	}
`;

export const CardContentWrapper = styled.div`
	display: flex;
	flex-direction: column;

	@media (min-width: 1024px) {
		flex-direction: row;
	}
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	top: 100px;
	position: relative;

	@media (min-width: 1024px) {
		top: 50%;
	}

	.modal-close-icon {
		cursor: pointer;
		border-radius: 25px;
		width: 50px;
		height: 50px;
		transform: rotate(90deg);
		justify-content: center;
		padding: 10px;
		border-radius: 35px;
		border: 1.136px solid var(--main-secondary-text-color);

		path {
			fill: var(--main-secondary-text-color);
		}
	}
`;

export const ImageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	img {
		height: 140px;
		width: auto;
		max-width: 248px;
		border-radius: 15px;
		box-shadow:
			0px 0px 20px 0px rgba(0, 0, 0, 0.25) inset,
			0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	}

	@media (min-width: 1024px) {
		align-items: flex-start;
		margin-right: 20px;
		img {
			height: auto;
			width: 243px;
			max-height: 200px;
		}
	}
`;

export const ImageContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	@media (min-width: 1024px) {
		align-items: flex-start;
	}
`;

export const GameAffiliateName = styled.span`
	align-items: center;
	display: flex;
	justify-content: center;
	text-transform: uppercase;
	height: 30px;
	align-self: stretch;
	color: var(--secondary-text-color);
	text-align: center;
	font-size: 12px;
	line-height: 20px;
	letter-spacing: 0.3px;

	@media (min-width: 1024px) {
		justify-content: flex-start;
	}
`;

export const GameName = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--gray-white, #fff);
	text-align: center;
	font-size: 20px;
	font-weight: 600;
	line-height: 24px;
	letter-spacing: 0.75px;
	max-width: 254px;
	margin-bottom: 20px;

	@media (min-width: 1024px) {
		align-items: flex-start;
		width: 100%;
		text-align: start;
		height: 70px;
		min-width: 211px;
		justify-content: flex-start;
		margin-bottom: 10px;
	}
`;

const BaseButton = styled.button`
	display: flex;
	width: 160px;
	height: 40px;
	justify-content: center;
	align-items: center;
	gap: 5px;
	border-radius: 20px;
	color: var(--Gray-00, #fff);
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
	border: none;
	cursor: pointer;
`;

export const PlayNowButton = styled(BaseButton)`
	background: var(--main-gradient);
	margin-bottom: 20px;

	@media (min-width: 1024px) {
		margin-bottom: 10px;
		min-width: 211px;
		width: 100%;
	}
`;

export const TryAgainButton = styled(BaseButton)`
	background: var(--main-explosive-gradient);
	@media (min-width: 1024px) {
		width: 100%;
		min-width: 211px;
	}
`;
